export default __webpack_public_path__ + "static/media/snailpaw2.06d8f683.jpeg";